import { RemoteDiagnosticsGetVddListByComChannelGeneric } from '../remote-diagnostics.model';
import { LogicalLinkVddList } from './mockedVddList.model';
export class LL_0051_HMI_CAN59 implements LogicalLinkVddList {
  vddList(): RemoteDiagnosticsGetVddListByComChannelGeneric {
    return {
      service: 'DS_ReadDataByIdent',
      ecu: 'LL_0051_HMI_CAN59',
      type: 'ListOfVDDsByBaseVariant',
      structure: [
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'SecurityAlgorithmNumber',
          structure: [
            {
              TI_texttableentry: 'TI_BusIdentification',
              isRead: 'true',
              interval: '256',
              texttableentry: 'BusIdentification',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StatusDtcList',
              isRead: 'true',
              interval: '257',
              texttableentry: 'StatusDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StatusDtcHistory',
              isRead: 'true',
              interval: '258',
              texttableentry: 'StatusDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InfoDtcList',
              isRead: 'true',
              interval: '259',
              texttableentry: 'InfoDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InfoDtcHistory',
              isRead: 'true',
              interval: '260',
              texttableentry: 'InfoDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ServiceDtcList',
              isRead: 'true',
              interval: '261',
              texttableentry: 'ServiceDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ServiceDtcHistory',
              isRead: 'true',
              interval: '262',
              texttableentry: 'ServiceDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WarningDtcList',
              isRead: 'true',
              interval: '263',
              texttableentry: 'WarningDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WarningDtcHistory',
              isRead: 'true',
              interval: '264',
              texttableentry: 'WarningDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ErrorDtcList',
              isRead: 'true',
              interval: '265',
              texttableentry: 'ErrorDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ErrorDtcHistory',
              isRead: 'true',
              interval: '266',
              texttableentry: 'ErrorDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ViessmannIdentificationNumber',
              isRead: 'true',
              interval: '377',
              texttableentry: 'ViessmannIdentificationNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_UnitsAndFormats',
              isRead: 'true',
              interval: '382',
              texttableentry: 'UnitsAndFormats',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_Date',
              isRead: 'true',
              interval: '505',
              texttableentry: 'Date',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_Time',
              isRead: 'true',
              interval: '506',
              texttableentry: 'Time',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_Language',
              isRead: 'true',
              interval: '510',
              texttableentry: 'Language',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDefaultValues',
              isRead: 'false',
              interval: '571',
              texttableentry: 'SetDefaultValues',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDefaultValuesDate',
              isRead: 'true',
              interval: '572',
              texttableentry: 'SetDefaultValuesDate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDeliveryStatus',
              isRead: 'false',
              interval: '575',
              texttableentry: 'SetDeliveryStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SoftwareVersion',
              isRead: 'true',
              interval: '580',
              texttableentry: 'SoftwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HardwareVersion',
              isRead: 'true',
              interval: '581',
              texttableentry: 'HardwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MacAddressLan',
              isRead: 'true',
              interval: '592',
              texttableentry: 'MacAddressLan',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayMac',
              isRead: 'true',
              interval: '593',
              texttableentry: 'GatewayMac',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteLocalNetworkStatus',
              isRead: 'true',
              interval: '602',
              texttableentry: 'GatewayRemoteLocalNetworkStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayApEnable',
              isRead: 'true',
              interval: '603',
              texttableentry: 'GatewayApEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayApDataSet',
              isRead: 'true',
              interval: '604',
              texttableentry: 'GatewayApDataSet',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteIp',
              isRead: 'true',
              interval: '607',
              texttableentry: 'GatewayRemoteIp',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteEnable',
              isRead: 'true',
              interval: '616',
              texttableentry: 'GatewayRemoteEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteSsid',
              isRead: 'false',
              interval: '617',
              texttableentry: 'GatewayRemoteSsid',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteIpStatic',
              isRead: 'true',
              interval: '618',
              texttableentry: 'GatewayRemoteIpStatic',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteScanNetwork',
              isRead: 'true',
              interval: '619',
              texttableentry: 'GatewayRemoteScanNetwork',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ServiceEngineer',
              isRead: 'true',
              interval: '623',
              texttableentry: 'ServiceEngineer',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteSignalStrength',
              isRead: 'true',
              interval: '900',
              texttableentry: 'GatewayRemoteSignalStrength',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MalfunctionIdentification',
              isRead: 'true',
              interval: '902',
              texttableentry: 'MalfunctionIdentification',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DisplaySettings',
              isRead: 'true',
              interval: '903',
              texttableentry: 'DisplaySettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DaylightSavingTimeActive',
              isRead: 'true',
              interval: '912',
              texttableentry: 'DaylightSavingTimeActive',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TradeFairMode',
              isRead: 'true',
              interval: '918',
              texttableentry: 'TradeFairMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_StartUpWizard',
              isRead: 'true',
              interval: '924',
              texttableentry: 'StartUpWizard',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicTraceabilityNumber',
              isRead: 'true',
              interval: '928',
              texttableentry: 'ElectronicTraceabilityNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrix',
              isRead: 'true',
              interval: '954',
              texttableentry: 'BusTopologyMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BootLoaderVersion',
              isRead: 'true',
              interval: '962',
              texttableentry: 'BootLoaderVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ActiveDiagnosticSession',
              isRead: 'true',
              interval: '964',
              texttableentry: 'ActiveDiagnosticSession',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AccentLedBar',
              isRead: 'true',
              interval: '1138',
              texttableentry: 'AccentLedBar',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BackendConnectionStatus',
              isRead: 'true',
              interval: '1165',
              texttableentry: 'BackendConnectionStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ResetDtcHistory',
              isRead: 'true',
              interval: '1166',
              texttableentry: 'ResetDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeInfoAlarmMessage',
              isRead: 'true',
              interval: '1175',
              texttableentry: 'AcknowledgeInfoAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeWarningAlarmMessage',
              isRead: 'true',
              interval: '1176',
              texttableentry: 'AcknowledgeWarningAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeServiceAlarmMessage',
              isRead: 'true',
              interval: '1177',
              texttableentry: 'AcknowledgeServiceAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeErrorAlarmMessage',
              isRead: 'true',
              interval: '1178',
              texttableentry: 'AcknowledgeErrorAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DisplayTestMode',
              isRead: 'true',
              interval: '1181',
              texttableentry: 'DisplayTestMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DisplayTouchTwoDimensionalCoordinates',
              isRead: 'true',
              interval: '1182',
              texttableentry: 'DisplayTouchTwoDimensionalCoordinates',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleOneTwo',
              isRead: 'true',
              interval: '1233',
              texttableentry: 'GatewayRemoteVisibleOneTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleThreeFour',
              isRead: 'true',
              interval: '1234',
              texttableentry: 'GatewayRemoteVisibleThreeFour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleFiveSix',
              isRead: 'true',
              interval: '1235',
              texttableentry: 'GatewayRemoteVisibleFiveSix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleSevenEight',
              isRead: 'true',
              interval: '1236',
              texttableentry: 'GatewayRemoteVisibleSevenEight',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleNineTen',
              isRead: 'true',
              interval: '1237',
              texttableentry: 'GatewayRemoteVisibleNineTen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixTwo',
              isRead: 'true',
              interval: '1286',
              texttableentry: 'BusTopologyMatrixTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixThree',
              isRead: 'true',
              interval: '1287',
              texttableentry: 'BusTopologyMatrixThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixFour',
              isRead: 'true',
              interval: '1288',
              texttableentry: 'BusTopologyMatrixFour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixFive',
              isRead: 'true',
              interval: '1289',
              texttableentry: 'BusTopologyMatrixFive',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DisplayStatistics',
              isRead: 'true',
              interval: '1449',
              texttableentry: 'DisplayStatistics',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SafetyRelevantRemoteUnlock',
              isRead: 'true',
              interval: '1467',
              texttableentry: 'SafetyRelevantRemoteUnlock',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OemProductVersion',
              isRead: 'true',
              interval: '1494',
              texttableentry: 'OemProductVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSettingSource',
              isRead: 'true',
              interval: '1504',
              texttableentry: 'TimeSettingSource',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InstallationWizardInProgress',
              isRead: 'true',
              interval: '1533',
              texttableentry: 'InstallationWizardInProgress',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigbeeEnable',
              isRead: 'true',
              interval: '1538',
              texttableentry: 'ZigbeeEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigbeeIdentification',
              isRead: 'true',
              interval: '1540',
              texttableentry: 'ZigbeeIdentification',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageOperationState',
              isRead: 'true',
              interval: '1552',
              texttableentry: 'ElectricalEnergyStorageOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemOperationState',
              isRead: 'true',
              interval: '1590',
              texttableentry: 'ElectricalEnergySystemOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PointOfCommonCouplingPower',
              isRead: 'true',
              interval: '1603',
              texttableentry: 'PointOfCommonCouplingPower',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MalfunctionUnitBlocked',
              isRead: 'true',
              interval: '1607',
              texttableentry: 'MalfunctionUnitBlocked',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SupportedFeatures',
              isRead: 'true',
              interval: '1660',
              texttableentry: 'SupportedFeatures',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageStateOfCharge',
              isRead: 'true',
              interval: '1664',
              texttableentry: 'ElectricalEnergyStorageStateOfCharge',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemPhotovoltaicConfiguration',
              isRead: 'true',
              interval: '1687',
              texttableentry: 'ElectricalEnergySystemPhotovoltaicConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ButtonMonitoringRawValues',
              isRead: 'true',
              interval: '1688',
              texttableentry: 'ButtonMonitoringRawValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SecondaryControllerSoftwareVersion',
              isRead: 'true',
              interval: '1689',
              texttableentry: 'SecondaryControllerSoftwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemPhotovoltaicStatus',
              isRead: 'true',
              interval: '1690',
              texttableentry: 'ElectricalEnergySystemPhotovoltaicStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetEnable',
              isRead: 'true',
              interval: '1694',
              texttableentry: 'GatewayEthernetEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetConfig',
              isRead: 'true',
              interval: '1695',
              texttableentry: 'GatewayEthernetConfig',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetIp',
              isRead: 'true',
              interval: '1696',
              texttableentry: 'GatewayEthernetIp',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetNetworkStatus',
              isRead: 'true',
              interval: '1697',
              texttableentry: 'GatewayEthernetNetworkStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SupportedFeaturesTelemetryControlUnit',
              isRead: 'true',
              interval: '1698',
              texttableentry: 'SupportedFeaturesTelemetryControlUnit',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ActivatedFeaturesTelemetryControlUnit',
              isRead: 'true',
              interval: '1699',
              texttableentry: 'ActivatedFeaturesTelemetryControlUnit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EebusPartnerInfo',
              isRead: 'true',
              interval: '1702',
              texttableentry: 'EebusPartnerInfo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EebusConnectionStatus',
              isRead: 'true',
              interval: '1703',
              texttableentry: 'EebusConnectionStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemConfiguration',
              isRead: 'true',
              interval: '1718',
              texttableentry: 'ElectricalEnergySystemConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageEnergyTransferStatistic',
              isRead: 'true',
              interval: '1801',
              texttableentry: 'ElectricalEnergyStorageEnergyTransferStatistic',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyProductionPhotovoltaic',
              isRead: 'true',
              interval: '1802',
              texttableentry: 'EnergyProductionPhotovoltaic',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyInverterDcInputOne',
              isRead: 'true',
              interval: '1807',
              texttableentry: 'ElectricalEnergyInverterDcInputOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyInverterDcInputTwo',
              isRead: 'true',
              interval: '1808',
              texttableentry: 'ElectricalEnergyInverterDcInputTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyInverterDcInputThree',
              isRead: 'true',
              interval: '1809',
              texttableentry: 'ElectricalEnergyInverterDcInputThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyInverterPowerAc',
              isRead: 'true',
              interval: '1810',
              texttableentry: 'ElectricalEnergyInverterPowerAc',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PointOfCommonCouplingConfiguredEnergyMeter',
              isRead: 'true',
              interval: '1812',
              texttableentry: 'PointOfCommonCouplingConfiguredEnergyMeter',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageCurrentPower',
              isRead: 'true',
              interval: '1836',
              texttableentry: 'ElectricalEnergyStorageCurrentPower',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BatteryTemperatureSensor',
              isRead: 'true',
              interval: '2240',
              texttableentry: 'BatteryTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitSafeStateStatus',
              isRead: 'true',
              interval: '2969',
              texttableentry: 'ElectronicControlUnitSafeStateStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TelemetryControlUnitTargetOperationMode',
              isRead: 'true',
              interval: '3188',
              texttableentry: 'TelemetryControlUnitTargetOperationMode',
              isWrite: 'false',
            },
          ],
        },
      ],
    };
  }
}
